// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.row-hover:hover {\n    background-color: rgba(0,0,0,.05);\n}\n.search-results-container {\n    position: absolute;\n    z-index: 1000;\n    width: 48%;\n    background-color: white;\n    border: 1px solid #ccc;\n}\n", ""]);
// Exports
module.exports = exports;
